<template>
  <div>
    <ng-button
      v-if="$vuetify.breakpoint.lgAndUp"
      icon-position="left"
      icon-name="mdi-upload"
      @click="openDialog"
      color="light"
      v-cloak
      :class="{ 'accent--text': loaded }"
    >
      {{ $t('product.custom.uploadFileMapButton') }}</ng-button
    >
    <ng-button
      v-else
      icon
      icon-name="mdi-upload"
      @click="openDialog"
      color="light"
      v-cloak
      :class="{ 'accent--text': loaded }"
    ></ng-button>
    <v-dialog v-model="isDialogOpened" @click:outside="reset" width="480">
      <ng-sheet class="upload-dialog">
        <h2>{{ $t('product.custom.loadGeoJsonBoundary') }}</h2>
        <v-alert class="my-4 pr-6" color="secondary">{{ $t('product.custom.geoJsonDetails') }}</v-alert>
        <v-file-input
          ref="fileInput"
          outlined
          dense
          show-size
          v-show="boundaryFileTarget"
          v-model="boundaryFileTarget"
          @change="handleOnChange"
          prepend-icon=""
          prepend-inner-icon="mdi-paperclip"
          :placeholder="this.$t('product.custom.geoJsonPlaceholder')"
          hide-details="auto"
          class="mb-2 mt-2 text-body-2"
        ></v-file-input>

        <v-alert v-if="errorMessage" dense outlined type="error" class="mt-4">
          {{ errorMessage }}
        </v-alert>

        <ng-button
          v-if="!boundaryData"
          class="mt-4"
          :loading="isPending"
          color="primary"
          x-large
          block
          @click="handleSelectButtonClick"
        >
          {{ $t('product.custom.uploadFile') }}
        </ng-button>

        <ng-button
          v-if="boundaryData"
          class="mt-4"
          :loading="isPending"
          color="primary"
          x-large
          block
          @click="handleAddToMap"
        >
          {{ $t('product.custom.addToMap') }}
        </ng-button>

        <ng-button class="upload-dialog__close" @click="reset" text icon icon-name="mdi-close" />
      </ng-sheet>
    </v-dialog>
  </div>
</template>
<script>
import { validateBoundaryFile } from './boundaryValidator';

export default {
  data() {
    return {
      isDialogOpened: false,
      boundaryFileTarget: undefined,
      isPending: false,
      boundaryData: undefined,
      errorMessage: null,
    };
  },
  props: {
    loaded: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openDialog() {
      this.isDialogOpened = true;
    },
    async handleOnChange(val) {
      if (val) {
        try {
          this.boundaryData = undefined;
          this.isPending = true;
          const result = await validateBoundaryFile(val);
          this.boundaryData = result;
          this.errorMessage = null;
          this.isPending = false;
        } catch (error) {
          this.errorMessage = this.getErrorMessage(error.key);
          this.isPending = false;
        }
      } else {
        this.errorMessage = null;
        this.boundaryData = undefined;
      }
    },
    handleAddToMap() {
      this.$emit('geojsonLoaded', { geometry: this.boundaryData, filename: this.boundaryFileTarget?.name });
      this.reset();
    },
    handleSelectButtonClick() {
      this.$refs.fileInput.$refs.input.click();
    },
    reset() {
      this.boundaryData = undefined;
      this.isPending = false;
      this.errorMessage = null;
      this.isDialogOpened = false;
      this.boundaryFileTarget = undefined;
    },
    getErrorMessage(key) {
      const errorMessageMapping = {
        network: this.$t('product.custom.networkError'),
        wrongJSON: this.$t('product.custom.wrongJSON'),
        wrongFormat: this.$t('product.custom.wrongFormat'),
        wrongCRS: this.$t('product.custom.wrongCRS'),
        unsupportedGeometry: this.$t('product.custom.multipleFeaturesNotSupported'),
        wrongGeoJSONFormat: this.$t('product.custom.unsupportedGeometry'),
        other: this.$t('product.custom.otherError'),
      };
      return errorMessageMapping[key || 'other'];
    },
  },
};
</script>

<style lang="scss">
.input-hidden {
  height: 0;
  overflow: hidden;
}

.upload-dialog {
  position: relative;

  &__close {
    position: absolute;
    right: 8px;
    top: 8px;
  }
}
</style>
